import React, { Component } from "react";

import {
  CListGroup,
  CListGroupItem,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle
} from "@coreui/react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import AcertosPorHabilidade from "../../../../components/Statistics/AcertosPorHabilidade";
import AcertosPorObjetivo from "../../../../components/Statistics/AcertosPorObjetivo";
import AcertosPorQuestao from "../../../../components/Statistics/AcertosPorQuestao";
import AcertosPorUnidadeTematica from "../../../../components/Statistics/AcertosPorUnidadeTematica";
import AlunoTurma from "../../../../components/Statistics/Comparison/AlunoTurma";
import AssuntoAvaliacao from "../../../../components/Statistics/Comparison/AssuntoAvaliacao";
import DataQFiltro from "../../../../components/Statistics/Comparison/DataQuestionsFiltro";
import ComparacaoEscola from "../../../../components/Statistics/Comparison/Escolas";
import HistogramaAluno from "../../../../components/Statistics/Comparison/HistogramaAluno";
import HistogramaEscola from "../../../../components/Statistics/Comparison/HistogramaEscola";
import HistogramaTurma from "../../../../components/Statistics/Comparison/HistogramaTurma";
import ListaNotasFiltro from "../../../../components/Statistics/Comparison/ListaNotasFiltro";
import ComparacaoRegional from "../../../../components/Statistics/Comparison/Regionais";
import ComparacaoTurma from "../../../../components/Statistics/Comparison/Turmas";
import { log } from "../../../../utils/log";

import "./style.css";

class EvaluationStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menu: "Lista de Notas",
      printDiv: React.createRef()
    };
  }

  async componentDidMount() {
    () => this.createLog();
  }

  createLog() {
    log(
      "access",
      this.props.currentRoute,
      `Acessou as estatísticas da lista ${this.props.title}${
        this.props.activity_id
          ? ` dentro da atividade com id ${this.props.activity_id}`
          : ""
      }`,
      this.props.activity_id,
      this.props.user.token,
      this.props.activity_id || null,
      this.props.general.active_roles.school_id || null
    );
  }

  getMenus() {
    return [
      {
        name: "Lista de Notas",
        component: <ListaNotasFiltro activity_id={this.props.activity_id} />
      },
      {
        name: "Descritor e Distrator",
        component: <DataQFiltro activity_id={this.props.activity_id} />
      },
      {
        name: "Acertos por Questão",
        component: <AcertosPorQuestao activity_id={this.props.activity_id} />
      },
      {
        name: "Acertos por Habilidade",
        component: <AcertosPorHabilidade activity_id={this.props.activity_id} />
      },
      {
        name: "Acertos por Objetivo",
        component: <AcertosPorObjetivo activity_id={this.props.activity_id} />
      },
      {
        name: "Acertos por Unidade Temática",
        component: (
          <AcertosPorUnidadeTematica activity_id={this.props.activity_id} />
        )
      },
      {
        name: "Comparação entre Turmas",
        component: <ComparacaoTurma activity_id={this.props.activity_id} />
      },
      {
        name: "Comparação entre Escolas",
        component: <ComparacaoEscola activity_id={this.props.activity_id} />
      },
      {
        name: "Comparação entre Regionais",
        component: (
          <ComparacaoRegional
            activity_id={this.props.activity_id}
            {...this.props.general.activer_roles}
          />
        )
      },
      {
        name: "Estudante x Unidade",
        component: <AlunoTurma activity_id={this.props.activity_id} />
      },
      {
        name: "Estudante x Habilidade",
        component: (
          <AssuntoAvaliacao
            activity_id={this.props.activity_id}
            key="alunoassunto"
          />
        )
      },
      {
        name: "Turma x Habilidade",
        component: (
          <AssuntoAvaliacao
            activity_id={this.props.activity_id}
            hideUser
            key="turmaassunto"
          />
        )
      },
      {
        name: "Escola x Habilidade",
        component: (
          <AssuntoAvaliacao
            activity_id={this.props.activity_id}
            hideUser
            hideRoom
            key="escolaassunto"
          />
        )
      },
      {
        name: "Histograma dos Estudantes",
        component: <HistogramaAluno activity_id={this.props.activity_id} />
      },
      {
        name: "Histograma das Turmas",
        component: <HistogramaTurma activity_id={this.props.activity_id} />
      },
      {
        name: "Histograma das Escolas",
        component: <HistogramaEscola activity_id={this.props.activity_id} />
      }
    ];
  }

  render() {
    return (
      <CModal
        size="lg w-100 h-100 m-0 p-2 mw-100"
        style={{ width: "100%", height: "100%" }}
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CModalTitle>
            Estatísticas da avaliação{" "}
            {this.props.title && `- ${this.props.title}`}
          </CModalTitle>
        </CModalHeader>
        <CModalBody className="p-0 d-flex" style={{ overflow: "auto" }}>
          <CListGroup
            style={{
              height: "100%",
              backgroundColor:
                "#f6f8f9" /* , borderRight:"1px solid rgba(0, 0, 21, 0.125)" */
            }}
          >
            {this.getMenus()
              .filter(menu => !menu.hideMenu)
              .map(menu => (
                <CListGroupItem
                  action
                  active={menu.name === this.state.menu}
                  style={{ border: "0", borderRadius: "0", minWidth: "250px" }}
                  className="cursor"
                  onClick={() => this.setState({ menu: menu.name })}
                >
                  {menu.name}
                </CListGroupItem>
              ))}
          </CListGroup>
          <div
            ref={this.state.printDiv}
            className="charts flex-1 d-flex justify-content-center"
            style={{ overflow: "auto" }}
          >
            <div className="mx-3 w-100">
              <div className="py-3 d-flex flex-column align-items-center container">
                <span className="est-text mb-3">
                  <h1>{this.state.menu}</h1>
                </span>
                {
                  this.getMenus().find(menu => menu.name === this.state.menu)
                    .component
                }
              </div>
            </div>
          </div>
        </CModalBody>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationStatistics);
